'use strict'

module.exports = function (node) {
  var id = node.name
  return '$$mathCodegen.getProperty("' + id + '", scope, ns)'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-codegen/lib/node/SymbolNode.js
// module id = oKDW
// module chunks = 0